import {primaryColor} from "assets/jss/global";
import {createStyles} from '@material-ui/core/styles';

const spinnerStyle = createStyles({
  container: {
    height: "100vh",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  loader: {
    color: primaryColor[0],
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  spinner: {
    marginTop: "10px",
    color: primaryColor[0],
  },
  spinnerColor: "#152F4D"
});

export default spinnerStyle;